goog.module('yext.developerconsole.routes');
goog.module.declareLegacyNamespace();

const router = goog.require('yext.storm.router');


var route = router.route;
const DeveloperConsole = {
  overview: route('developerconsole/'),
  viewApp: route('developerconsole/apps/:appId'),
  viewLogsApi: route('developerconsole/apps/:appId/logs/api'),
  fetchRows: route('developerconsole/apps/:appId/logs/:tab/fetchRows'),
  fetchRowDetails: route('developerconsole/apps/:appId/logs/:tab/fetchRowDetails'),
  logsDatatable: route('developerconsole/apps/:appId/logs/datatable'),
  logsDatatableCsv: route('developerconsole/apps/:appId/logs/datatableCsv'),
  logsDetailView: route('developerconsole/apps/:appId/logs/detailview/:requestId'),
  saveNewApp: route('developerconsole/saveNewApp'),
  editName: route('developerconsole/apps/:appId/name'),
  keys: route('developerconsole/apps/:appId/keys'),
  editContact: route('developerconsole/apps/:appId/contactInfo'),
  updatePermissions: route('developerconsole/apps/:appId/permissions'),
  deleteApp: route('developerconsole/apps/:appId'),
  yextApiErrorSearch: route('developerconsole/yextApiErrorSearch'),
  usageSummary: route('developerconsole/usageSummary'),
  errorSummary: route('developerconsole/errorSummary'),
  usageSummaryGraphs: route('developerconsole/usageSummaryGraphs'),
  updateAppField: route('developerconsole/apps/:appId'),
  uploadPhoto: route('developerconsole/uploadPhoto'),
  uploadScreenshots: route('developerconsole/uploadScreenshots'),
  validateNamespace: route('developerconsole/validateAppNamespace'),
  importFromGithub: route('developerconsole/importFromGithub'),
  applyAndSaveConfigTemplate: route('developerconsole/applyAndSaveConfigTemplate'),
  deleteConfigTemplate: route('developerconsole/deleteConfigTemplate'),
  revert: route('developerconsole/revert'),
  updateAppType: route('developerconsole/updateAppType'),
  addApp: route('developerconsole/addApp'),
};

const WebhooksController = {
  add: route('developerconsole/apps/:appId/addWebhook'),
  configure: route('developerconsole/apps/:appId/configureWebhook/:typeId'),
  view: route('developerconsole/apps/:appId/webhooks'),
  save: route('developerconsole/apps/:appId/webhooks'),
  edit: route('developerconsole/apps/:appId/webhooks/:webhookId/edit'),
  delete: route('developerconsole/apps/:appId/webhooks/:webhookId'),
  webhooksTestRequest: route('developerconsole/webhooksTestRequest'),
  signingSecret: route('developerconsole/apps/:appId/signingSecret'),
  saveGeneralSettings: route('developerconsole/apps/:appId/webhooksgeneralsettings'),
};

const NotificationsController = {
  save: route('developerconsole/notifications'),
};

exports = {
  DeveloperConsole,
  WebhooksController,
  NotificationsController,
};
